var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-title',{attrs:{"title":"Dynamic analysis","subtitle":"Select and analyse specific parts of the video"}}),(_vm.testData !== null)?_c('div',{staticClass:"container"},[_c('bg-section-video',{attrs:{"data":_vm.testData,"customControls":false}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }